export const CadastrouEquipe: { [index: string]: any } = {
  '0': 'NÃO',
  '1': 'SIM',
}
